/* eslint-disable react/style-prop-object */
import React from "react";

import { useFormik } from "formik";
import * as Yup from "yup";
import { Input } from "../../../../../../Helpers/Input/Input";
import Button from "../../../../../../Helpers/Button/Button";
import {
	useGetSpecificDeviceQuery,
	useUpdateDeviceByIdMutation,
} from "../../../../../../../Redux/Devicestwo";
import { toast } from "react-toastify";
import trans from "../../../../../../../utils";
import Loader from "../../../../../../Helpers/Loader/Loader";
import { useSelector } from "react-redux";
import {
	VolumeInputValue,
	VolumeValue,
} from "../../../../../../../JsHelpers/PlatformUnits";

const FuelDropThreshold = ({
	device,
	setControlsPopup,
	setIsControlsPopup,
}) => {
	const {
		data: oldData,
		refetch,
		isLoading,
	} = useGetSpecificDeviceQuery(device?.id, { skip: !device?.id });
	const [updateDeviceById] = useUpdateDeviceByIdMutation();
	const inf = useSelector((state) => state.users.user);
	console.log("oldData", oldData);
	const formik = useFormik({
		initialValues: {
			fuelDropThreshold:
				VolumeInputValue(
					oldData?.length > 0 && oldData?.[0].attributes?.fuelDropThreshold,
					inf.attributes.volumeUnit || "ltr"
				) || "",
		},
		enableReinitialize: true,
		validationSchema: Yup.object({
			fuelDropThreshold: Yup.number()
				.min(1, trans("Fuel Drop Threshold must be more than 0 "))
				.required(trans("Fuel Drop Threshold is required")),
		}),
		onSubmit: async (val) => {
			try {
				const body = {
					id: device?.id,
					attributes: {
						speedLimit: oldData?.[0].attributes?.speedLimit,
						fuelDropThreshold: VolumeValue(
							val.fuelDropThreshold,
							inf.attributes?.volumeUnit || "ltr"
						),
						fuelIncreaseThreshold:
							oldData?.[0].attributes?.fuelIncreaseThreshold,
					},
					groupId: oldData?.[0].groupId,
					calendarId: oldData?.[0].calendarId,
					name: oldData?.[0].name,
					uniqueId: oldData?.[0].uniqueId,
					status: oldData?.[0].status,
					lastUpdate: oldData?.[0].lastUpdate,
					positionId: oldData?.[0].positionId,
					phone: oldData?.[0].phone,
					model: oldData?.[0].model,
					contact: oldData?.[0].contact,
					category: oldData?.[0].category,
					disabled: oldData?.[0].disabled,
					expirationTime: oldData?.[0].expirationTime,
				};
				await updateDeviceById({ id: device?.id, val: body }).unwrap();
				await refetch();
				setControlsPopup("");
				setIsControlsPopup(false);
				toast.success(trans("Fuel Drop Threshold has been set successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} catch (error) {
				toast.error(
					trans(
						"Error while setting fuel drop threshold, please try again later"
					),
					{
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					}
				);
			}
		},
	});

	if (isLoading) return <Loader />;

	return (
		<form onSubmit={formik.handleSubmit}>
			<div>
				<Input
					title={trans("Enter Fuel Drop Threshold")}
					type="number"
					placeholder={`100 ${trans(
						trans(inf.attributes?.volumeUnit || "ltr")
					)}`}
					id="fuelDropThreshold"
					name="fuelDropThreshold"
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					value={formik.values.fuelDropThreshold}
				/>
				{formik.touched.fuelDropThreshold && formik.errors.fuelDropThreshold ? (
					<div className="validation">{formik.errors.fuelDropThreshold}</div>
				) : null}
				<div className="w-100 flex-row justify-end mt-12">
					<Button text={trans("Save")} htmlType="submit" type="primary" />
				</div>
			</div>
		</form>
	);
};

export default FuelDropThreshold;
